import FormDialog from "../../helpers/FormDialog";
import { Provinces, Districts, Sectors, Cells, Villages } from "rwanda";
import { useState, useEffect } from "react";
import StepperForm from "helpers/StepperForm";
import EmployeeForm from "../../helpers/EmployeeForm";

export default function ParentsEdit({ open, onSuccess, setOpen, resourceId, value, setValue0 }) {
  const [fatherLocationData, setFatherLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  const [motherLocationData, setMotherLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  useEffect(() => {
    if (open) {

      // Initialize Father's Location
      const initializeFatherLocation = () => {
        const fp = value.fatherProvince;
        if (fp) {
          const districts = Districts(fp);
          const fd = value.fatherDistrict;
          const sectors = fd ? Sectors(fp, fd) : [];
          const fs = value.fatherSector;
          const cells = fs ? Cells(fp, fd, fs) : [];
          const fc = value.fatherCell;
          const villages = fc ? Villages(fp, fd, fs, fc) : [];

          setFatherLocationData(prev => ({
            ...prev,
            districts,
            sectors,
            cells,
            villages
          }));
        }
      };

      // Initialize Mother's Location
      const initializeMotherLocation = () => {
        const mp = value.motherProvince;
        if (mp) {
          const districts = Districts(mp);
          const md = value.motherDistrict;
          const sectors = md ? Sectors(mp, md) : [];
          const ms = value.motherSector;
          const cells = ms ? Cells(mp, md, ms) : [];
          const mc = value.motherCell;
          const villages = mc ? Villages(mp, md, ms, mc) : [];

          setMotherLocationData(prev => ({
            ...prev,
            districts,
            sectors,
            cells,
            villages
          }));
        }
      };

      initializeFatherLocation();
      initializeMotherLocation();
    }
  }, [open, value]);
  const fields = [

    {
      name: "fatherResidence",
      label: "Father's Details",
      type: "group",
      fields: [
        {
          name: "fatherName",
          label: "Names of your Father:",
          type: "text",
          value: value["fatherName"],
          required: true,
          setValue: (val) => setValue0("fatherName", val),
        },
        {
          name: "fatherOccupation",
          label: "Father occupation",
          type: "text",
          value: value["fatherOccupation"],
          required: true,
          setValue: (val) => setValue0("fatherOccupation", val),
        },
        {
          name: "parentsPlaceOfOrigin",
          label: "Parents place of Origin",
          type: "text",
          value: value["parentsPlaceOfOrigin"],
          required: true,
          setValue: (val) => setValue0("parentsPlaceOfOrigin", val),
        },
        {
          name: "fatherProvince",
          label: "Province",
          type: "select",
          value: value["fatherProvince"],
          required: true,
          values: fatherLocationData.provinces.map((province) => ({
            label: province,
            value: province,
          })),
          setValue: (val) => {
            const districts = Districts(val);
            setFatherLocationData((prev) => ({
              ...prev,
              districts,
              sectors: [],
              cells: [],
              villages: [],
            }));
            setValue0("fatherProvince", val);
            setValue0("fatherDistrict", "");
            setValue0("fatherSector", "");
            setValue0("fatherCell", "");
            setValue0("fatherVillage", "");
          },
        },
        {
          name: "fatherDistrict",
          label: "District",
          type: "select",
          value: value["fatherDistrict"],
          required: true,
          values: fatherLocationData.districts.map((district) => ({
            label: district,
            value: district,
          })),
          setValue: (val) => {
            const sectors = Sectors(value["fatherProvince"], val);
            setFatherLocationData((prev) => ({
              ...prev,
              sectors: sectors || [],
              cells: [],
              villages: [],
            }));
            setValue0("fatherDistrict", val);
            setValue0("fatherSector", "");
            setValue0("fatherCell", "");
            setValue0("fatherVillage", "");
          },
        },
        {
          name: "fatherSector",
          label: "Sector",
          type: "select",
          value: value["fatherSector"],
          required: true,
          values: fatherLocationData.sectors.map((sector) => ({
            label: sector,
            value: sector,
          })),
          setValue: (val) => {
            const cells = Cells(value["fatherProvince"], value["fatherDistrict"], val);
            setFatherLocationData((prev) => ({
              ...prev,
              cells: cells || [],
              villages: [],
            }));
            setValue0("fatherSector", val);
            setValue0("fatherCell", "");
            setValue0("fatherVillage", "");
          },
        },
        {
          name: "fatherCell",
          label: "Cell",
          type: "select",
          value: value["fatherCell"],
          required: true,
          values: fatherLocationData.cells.map((cell) => ({
            label: cell,
            value: cell,
          })),
          setValue: (val) => {
            const villages = Villages(
              value["fatherProvince"],
              value["fatherDistrict"],
              value["fatherSector"],
              val
            );
            setFatherLocationData((prev) => ({
              ...prev,
              villages: villages || [],
            }));
            setValue0("fatherCell", val);
            setValue0("fatherVillage", "");
          },
        },
        {
          name: "fatherVillage",
          label: "Village",
          type: "select",
          value: value["fatherVillage"],
          required: true,
          values: fatherLocationData.villages.map((village) => ({
            label: village,
            value: village,
          })),
          setValue: (val) => setValue0("fatherVillage", val),
        },
        {
          name: "fatherStreet",
          label: "Father Street",
          type: "text",
          value: value["fatherStreet"],
          required: true,
          setValue: (val) => setValue0("fatherStreet", val),
        },
        {
          name: "fatherHouseNo",
          label: "Father House No",
          type: "text",
          value: value["fatherHouseNo"],
          required: true,
          setValue: (val) => setValue0("fatherHouseNo", val),
        },
        {
          name: "fatherVillageLeaderName",
          label: "Father Village Leader Name",
          type: "text",
          value: value["fatherVillageLeaderName"],
          required: true,
          setValue: (val) => setValue0("fatherVillageLeaderName", val),
        },
        {
          name: "fatherVillageLeaderMobile",
          label: "Father Village Leader Phone",
          type: "tel",
          value: value["fatherVillageLeaderMobile"],
          required: true,
          setValue: (val) => setValue0("fatherVillageLeaderMobile", val),
        },

      ],
    },
    {
      name: "motherResidence",
      label: "Mother's Details",
      type: "group",
      fields: [
        {
          name: "motherName",
          label: "Name of your Mother",
          type: "text",
          value: value["motherName"],
          required: true,
          setValue: (val) => setValue0("motherName", val),
        },
        {
          name: "motherOccupation",
          label: "Mother occupation",
          type: "text",
          value: value["motherOccupation"],
          required: true,
          setValue: (val) => setValue0("motherOccupation", val),
        },
        {
          name: "motherProvince",
          label: "Province",
          type: "select",
          value: value["motherProvince"],
          required: true,
          values: motherLocationData.provinces.map((province) => ({
            label: province,
            value: province,
          })),
          setValue: (val) => {
            const districts = Districts(val);
            setMotherLocationData((prev) => ({
              ...prev,
              districts,
              sectors: [],
              cells: [],
              villages: [],
            }));
            setValue0("motherProvince", val);
            setValue0("motherDistrict", "");
            setValue0("motherSector", "");
            setValue0("motherCell", "");
            setValue0("motherVillage", "");
          },
        },
        {
          name: "motherDistrict",
          label: "District",
          type: "select",
          value: value["motherDistrict"],
          required: true,
          values: motherLocationData.districts.map((district) => ({
            label: district,
            value: district,
          })),
          setValue: (val) => {
            const sectors = Sectors(value["motherProvince"], val);
            setMotherLocationData((prev) => ({
              ...prev,
              sectors: sectors || [],
              cells: [],
              villages: [],
            }));
            setValue0("motherDistrict", val);
            setValue0("motherSector", "");
            setValue0("motherCell", "");
            setValue0("motherVillage", "");
          },
        },
        {
          name: "motherSector",
          label: "Sector",
          type: "select",
          value: value["motherSector"],
          required: true,
          values: motherLocationData.sectors.map((sector) => ({
            label: sector,
            value: sector,
          })),
          setValue: (val) => {
            const cells = Cells(value["motherProvince"], value["motherDistrict"], val);
            setMotherLocationData((prev) => ({
              ...prev,
              cells: cells || [],
              villages: [],
            }));
            setValue0("motherSector", val);
            setValue0("motherCell", "");
            setValue0("motherVillage", "");
          },
        },
        {
          name: "motherCell",
          label: "Cell",
          type: "select",
          value: value["motherCell"],
          required: true,
          values: motherLocationData.cells.map((cell) => ({
            label: cell,
            value: cell,
          })),
          setValue: (val) => {
            const villages = Villages(
              value["motherProvince"],
              value["motherDistrict"],
              value["motherSector"],
              val
            );
            setMotherLocationData((prev) => ({
              ...prev,
              villages: villages || [],
            }));
            setValue0("motherCell", val);
            setValue0("motherVillage", "");
          },
        },
        {
          name: "motherVillage",
          label: "Village",
          type: "select",
          value: value["motherVillage"],
          required: true,
          values: motherLocationData.villages.map((village) => ({
            label: village,
            value: village,
          })),
          setValue: (val) => setValue0("motherVillage", val),
        },
        {
          name: "motherStreet",
          label: "Mother Street",
          type: "text",
          value: value["motherStreet"],
          required: true,
          setValue: (val) => setValue0("motherStreet", val),
        },
        {
          name: "motherHouseNo",
          label: "Mother House No",
          type: "text",
          value: value["motherHouseNo"],
          required: true,
          setValue: (val) => setValue0("motherHouseNo", val),
        },
        {
          name: "motherVillageLeaderName",
          label: "Mother Village Leader Name",
          type: "text",
          value: value["motherVillageLeaderName"],
          required: true,
          setValue: (val) => setValue0("motherVillageLeaderName", val),
        },
        {
          name: "motherVillageLeaderMobile",
          label: "Mother Village Leader Phone",
          type: "tel",
          value: value["motherVillageLeaderMobile"],
          required: true,
          setValue: (val) => setValue0("motherVillageLeaderMobile", val),
        },
      ],
    },
  ];

  return (
    <FormDialog
      maxWidth={"md"}
      open={open}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={open === 1 ? "/api/resource/create" : `/api/resource/parent-info/update/${resourceId}`}
      title={open === 1 ? "Create Parent Details" : "Edit Parent Details"}
      fields={fields}
    />
  );
}